<template lang="pug">
  .home

    include mixins.pug

    Navbar
    .section.list(v-if='!showDetail')
      .subtitle Vendedor
      .level.panel
        form(@submit.prevent='searchAction').level-left
          .level-item
            input.input(placeholder='Nombre' v-model='search.nom_ven')
          .level-item
            button.button.is-primary(:class="{'is-loading': searching}") Buscar
      progress.progress.is-small.is-primary(v-if='searching' max='100') 50

      table.table.is-bordered.is-striped.is-fullwidth.is-hoverable
        thead
          tr
            th Vendedor
            th Nombre
            th Dirección
            th Teléfono
            th Ciudad
            th Comisión
            th Obs
            th Descuento IPS
            th Dcto Corp
            th Acciones
        tbody(v-for='row in vendedorList')
          tr
            td {{ row.vendedor }}
            td {{ row.nom_ven }}
            td {{ row.dir_ven }}
            td {{ row.tel_ven }}
            td {{ row.ciu_ven }}
            td {{ row.com_ven }}
            td {{ row.obs }}
            td {{ row.desc_ips ? 'Si' : 'No' }}
            td {{ row.dcto_corp ? 'Si' : 'No' }}
            td.has-text-centered
              button.button.is-primary(@click.prevent='verDatos(row)') Datos

    .section.detail(v-else @keyup.esc='showDetail = false')
      h1.title Detalles de vendedor
        form.form
          .columns
            +textField('Vendedor', 'vendedorInstance.vendedor', 'vendedorInput')
            +textField('Nombre', 'vendedorInstance.nom_ven')
          .columns
            +textField('Dirección', 'vendedorInstance.dir_ven')
            +textField('Teléfono', 'vendedorInstance.tel_ven')
          .columns
            +textField('Ciudad', 'vendedorInstance.ciu_ven')
            +textField('Comisión', 'vendedorInstance.com_ven')
          .columns
            +textField('Obs', 'vendedorInstance.obs')
            +checkboxField('Descuento IPS', 'vendedorInstance.desc_ips')
          .columns
            +checkboxField('Dcto Corp', 'vendedorInstance.dcto_corp')
          button.button.is-info(@click.prevent='showDetail = false') Volver

</template>

<script>

import Navbar from '@/components/Navbar.vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

async function busqueda(search) {
  var query = firebase.firestore().collection('vendedor').limit(100)

  // firebase no soporte rage search (<=, >=, etc.) con más de un campo.
  if(search.nom_ven) 
    query = query.where('nom_ven', '>=', search.nom_ven)
  let vendedorList = []

  return query.get().then(snapshot => {
    snapshot.forEach(doc => vendedorList.push(doc.data()))
    return vendedorList
  })
}

export default {
  data () {
    return {
      vendedorList: [],
      vendedorInstance: {}, 
      search: {
        nom_ven: null,
      },
      searching: false,
      showDetail: false
    }
  },
  filters: {
    dateFmt(date) {
      if (date)
        return date.split('T')[0]
      return date
    }
  },
  components: {
    Navbar
  },
  created: function() {
    this.searching = true
    firebase.auth().onAuthStateChanged(user => {
      busqueda(this.search).then(list => {
        this.vendedorList = list
        this.searching = false
      })
    })
  },
  methods: {
    searchAction: function () {
      this.searching = true
      busqueda(this.search).then(list => {
        this.vendedorList = list
        this.searching = false
      })
    },
    verDatos: function (instance) {
      this.vendedorInstance = instance
      this.showDetail = true
      this.$nextTick(() => this.$refs.vendedorInput.focus())
    }
  }
}
</script>
